import posthog from "posthog-js";
import { isProduction } from "@/Environment";

export function identifyPostHogUser(
  userId: string,
  email: string,
  companyId: string,
  companyName: string,
): void {
  if (!isProduction()) {
    return;
  }

  posthog.identify(userId, { email });
  posthog.group("company", companyId, { name: companyName });
}
